<template>
  <PrimeMultiSelect
    :model-value="selectedStatus"
    :options="statusOptions"
    option-label="name"
    placeholder="Status"
    selected-items-label="Status"
    :max-selected-labels="0"
    :pt="{
      root: {
        class:
          'tw-h-10 tw-min-w-[10rem] md:tw-w-[10rem] tw-cursor-pointer tw-items-center tw-border-gray-300 tw-bg-gray-50 tw-px-5 tw-py-2.5 ' +
          buttonHoverCss +
          (isDropdownOpen || selectedStatus.length > 0 ? ' ' + buttonsActiveStyle : ''),
      },
      labelContainer: { class: 'tw-stroke-gray-700 tw-text-gray-700' },
      label: { class: 'tw-font-semibold tw-text-gray-700 tw-p-0 tw-text-sm' },
      dropdown: 'tw-h-3 tw-w-3  tw-stroke-gray-700 tw-text-gray-700',
      listContainer: { class: 'tw-min-w-[23rem]' },
      option: {
        class: buttonHoverCss,
      },
      pcFilterIconContainer: {
        root: { class: 'tw-hidden' },
      },
      pcFilter: {
        root: { class: 'tw-hidden' },
      },
      filterContainer: {
        class: 'tw-hidden',
      },
      header: {
        class: 'tw-hidden',
      },
      pcOptionCheckbox: {
        root: { class: 'tw-relative' },
        box: {
          class: ['tw-border-gray-700', 'tw-bg-white'],
        },
        Icon: {
          class: ` ${getThemeTokenString([
            'dark-background',
            'dark-border',
          ])} tw-h-full tw-w-full tw-p-1 tw-stroke-white`,
        },
      },
      pcHeaderCheckbox: {
        root: { class: 'tw-hidden' },
      },
      trigger: {
        class: 'tw-hidden',
      },
      input: {
        class: 'tw-hidden',
      },
    }"
    @update:model-value="updateSelectedStatus"
    @before-show="isDropdownOpen = true"
    @before-hide="isDropdownOpen = false"
  />
</template>

<script setup lang="ts">
import { ActionRequestStatus } from '@torticity/types'

const { getThemeTokenString } = useTheme()

const buttonHoverCss = getThemeTokenString(['hover-background', 'hover-border'])

const buttonsActiveStyle = getThemeTokenString(['light-background', 'dark-border'])

defineProps<{
  selectedStatus: Array<{ code: ActionRequestStatus; name: string }>
  statusOptions: Array<{ code: ActionRequestStatus; name: string }>
}>()

const emit = defineEmits(['update:selectedStatus'])

function updateSelectedStatus(value: Array<{ code: ActionRequestStatus; name: string }>) {
  emit('update:selectedStatus', value)
}

const isDropdownOpen = ref(false)
</script>
